<template>
  <div class="content page-content" v-loading="loading">
    <div class="table-operate-nav">
      <ListButton :buttonObj="buttonObj" @create="handleCreate"></ListButton>
      <el-button type="text" icon="el-icon-refresh" @click="fetchData">刷新</el-button>
    </div>
    <el-row>
      <Table
        ref="table"
        border
        :props="table.props"
        :header="table.header.filter(item => item.isShow === true)"
        :data="table.data"
        :selection-type="table.selectionType"
      />
      <pagination
        v-bind:currentpage="currentPage"
        v-bind:pagesize="pageSize"
        v-bind:totalcount="totalCount"
        @handle-size-change="handleSizeChange"
        @handle-current-change="handleCurrentChange"
      ></pagination>
    </el-row>
    <!--详情-->
    <el-drawer
      :visible.sync="drawer"
      size="60%"
      :modal="false"
      :destroy-on-close="true"
      class="detail-drawer"
      :with-header="false"
    >
      <Read
        v-if="drawer"
        :landingPageForm="landingPageForm"
        :tabActiveName="drawerTabsActiveName"
        :showTip="showTip"
        @reload-content="handleReloadContent"
        @closeDrawer="handleCloseDrawer"
      ></Read>
    </el-drawer>
  </div>
</template>
<script>
import { Table } from '@ccprivate/admin-toolkit'
import ListButton from '@/components/ListButton'
import { debounce } from 'lodash'
import Read from './LandingPageRead'

export default {
  components: {
    Table,
    ListButton,
    Read
  },
  inject: ['projectOrder'],
  data() {
    return {
      showTip: true,
      drawer: false,
      landingPageId: null,
      drawerTabsActiveName: 'detail',
      landingPageForm: {},
      loading: false,
      buttonObj: {
        title: '落地页',
        permissionData: 'landingPage:add'
      },
      landingPageClassList: [],
      dialogTableVisible: false,
      showClose: false,
      checkTableHeader: [],
      tableHeader: [],
      pageSize: 10,
      // 当前页码:pageNum
      currentPage: 1,
      totalCount: 1,
      // 查询的页码
      start: 1,
      filter: {},
      table: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        // table的width全部需要改成min-width，并且保证自定义之后表格不乱
        header: [
          {
            label: '落地页',
            align: 'left',
            prop: 'landingPageName',
            fixed: 'left',
            'min-width': 380,
            isShow: true,
            'show-overflow-tooltip': false,
            render: (h, { row }) => {
              return (
                <div style="display:flex">
                  <div
                    v-loading={row.transcodeStatus !== 0}
                    element-loading-text={this.$consts.transcodeStatusText[row.transcodeStatus]}
                    element-loading-spinner="icon-empty"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    style="width:80px"
                  >
                    <MediaView
                      width="80px"
                      height="50px"
                      mediaClassId={['ts', 'mp4'].includes(row.format) ? 2 : 1}
                      src={row.landingPageIcon}
                      previewSrc={row.mp4Url}
                    ></MediaView>
                  </div>
                  <div>
                    <el-tooltip content={row.landingPageName} placement="top">
                      <div style="padding-left: 12px">{row.landingPageName}</div>
                    </el-tooltip>
                    <div style="padding:6px 0 0 12px;color:#999">ID: {row.landingPageId}</div>
                  </div>
                </div>
              )
            }
          },
          {
            label: '落地页类型',
            align: 'left',
            prop: 'landingPageClass.landingPageClassName',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true
          },
          {
            label: '状态',
            align: 'left',
            prop: 'transcodeStatus',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return ['已完成', '转码中', '转码失败'][row.transcodeStatus]
            }
          },
          {
            label: '广告主',
            align: 'left',
            prop: 'partnerName',
            'min-width': 150,
            isShow: this.$service.state.user.accountType === '1', // 1为代理商，广告主不显示
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return row.adDspPartner ? row.adDspPartner.partnerName : ''
            }
          },
          {
            label: '时长',
            align: 'left',
            prop: 'duration',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return `${row.duration} S`
            }
          },
          {
            label: '创建时间',
            align: 'left',
            prop: 'createTime',
            'min-width': 180,
            isShow: true,
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return this.$moment(row.createTime).format('YYYY-MM-DD HH:mm:ss')
            }
          },
          {
            label: '操作栏',
            align: 'left',
            isShow: true,
            'min-width': 120,
            render: (h, { row }) => {
              return h('div', [
                h(
                  'el-button',
                  {
                    props: {
                      type: 'text',
                      disabled: row.transcodeStatus === 1 || row.transcodeStatus === 2
                    },
                    class: 'el-table-button-text',
                    on: {
                      click: (event) => {
                        event.stopPropagation()
                        this.handleEdit(row)
                      }
                    },
                    directives: [
                      {
                        name: 'permission',
                        value: 'landingPage:edit'
                      }
                    ]
                  },
                  '编辑'
                ),
                h(
                  'el-button',
                  {
                    props: {
                      type: 'text'
                    },
                    class: 'el-table-button-text',
                    on: {
                      click: (event) => {
                        event.stopPropagation()
                        this.handleRead(row)
                      }
                    },
                    directives: [
                      {
                        name: 'permission',
                        value: 'landingPage:list'
                      }
                    ]
                  },
                  '详情'
                ),
                h(
                  'el-dropdown',
                  {
                    props: {
                      trigger: 'click'
                    },
                    style: {
                      'margin-left': '10px'
                    },
                    on: {
                      command: (event) => {
                        this.handleCommand(row, event)
                      }
                    }
                  },
                  [
                    h('span', {
                      class: 'el-icon-more',
                      style: {
                        color: '#1890FF',
                        lineHeight: '24px',
                        cursor: 'pointer',
                        transform: 'rotate(90deg)'
                      }
                    }),
                    h(
                      'el-dropdown-menu',
                      {
                        slot: 'dropdown',
                        style: {
                          'width': '120px'
                        }
                      },
                      [
                        h(
                          'el-dropdown-item',
                          {
                            props: {
                              command: '下载',
                              disabled: row.transcodeStatus !== 0
                            },
                            directives: [
                              {
                                name: 'permission',
                                value: 'landingPage:download'
                              }
                            ]
                          },
                          '下载'
                        )
                      ]
                    )
                  ]
                )
              ])
            }
          }
        ],
        data: [],
        selectionType: 'none'
      }
    }
  },
  watch: {
    'projectOrder.selectForm': {
      handler(newVal, oldVal) {
        this.currentPage = 1
        this.pageSize = 10
        this.fetchData()
      },
      deep: true
    },
    'projectOrder.searchParam'(newValue, oldValue) {
      this.currentPage = 1
      this.pageSize = 10
      this.selected = []
      this.table.selected = []
      this.selectedRow = []
    },
    'projectOrder.timeList': {
      handler() {
        this.fetchData()
      },
      deep: true
    }
  },
  methods: {
    fetchData() {
      this.loading = true
      this.filter.pageNo = this.currentPage
      this.filter.pageSize = this.pageSize
      this.filter.order = 'desc'
      this.filter.sort = 'landingPageId'
      this.filter.partnerName = this.projectOrder.selectForm.materialLibraryPartnerName
        ? this.projectOrder.selectForm.materialLibraryPartnerName
        : undefined
      if (this.projectOrder.timeList) {
        this.filter.startDateX = this.$moment(this.projectOrder.timeList[0]).format(
          'YYYY-MM-DD 00:00:00'
        )
        this.filter.endDateX = this.$moment(this.projectOrder.timeList[1]).format(
          'YYYY-MM-DD 23:59:59'
        )
      } else {
        this.filter.startDateX = undefined
        this.filter.endDateX = undefined
      }
      this.filter.searchParamType = this.projectOrder.selectNameType
      this.filter.searchParam = this.projectOrder.searchParam
      this.$service
        .getLandingPageList(this.filter)
        .then((data) => {
          this.totalCount = data.total
          this.$nextTick(() => {
            this.table.data = data.rows
          })
          this.loading = false
        })
        .catch((e) => {
          this.loading = false
        })
    },
    handleReloadContent() {
      this.fetchData()
      this.handleOpenDrawer()
    },
    handleOpenDrawer() {
      this.loading = true
      return this.$service
        .getLandingPageInfo({ landingPageId: this.landingPageId })
        .then((data) => {
          if (data) {
            this.landingPageForm = data
            this.loading = false
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    handleCloseDrawer() {
      this.drawer = false
    },
    handleCreate() {
      this.$emit('create')
    },
    handleEdit(row) {
      this.$emit('edit', row)
    },
    async handleRead(row) {
      this.landingPageId = row.landingPageId
      await this.handleOpenDrawer()
      this.drawer = true
      this.drawerTabsActiveName = 'detail'
    },
    // 表格操作
    handleRefresh() {
      this.currentPage = 1
      this.filter = {}
      this.fetchData()
    },
    // 每页显示数据量变更, 如每页显示10条变成每页显示20时,val=20
    handleSizeChange(val) {
      this.pageSize = val
      this.fetchData()
    },
    // 页码变更, 如第1页变成第2页时,val=2
    handleCurrentChange(val) {
      this.currentPage = val
      this.fetchData()
    },
    handleFilterChange(type, filter) {
      if (filter) {
        this.filter = filter
      }
      if (type === 'query') {
        this.pagination.currentPage = 1
      }
      this.fetchData()
    },
    handleCommand(e, command) {
      if (command === '下载') {
        if (e.landingPageUrl) {
          window.open(e.landingPageUrl)
        }
      }
    }
  },
  created() {
    this.table.data = []
    this.fetchData()
    this.fetchDataDebounced = debounce(this.fetchData, 500)
  }
}
</script>
<style lang="stylus" scoped>
.page-content
  padding 0 16px
>>> .table-input input
  border none
  line-height 22px
  height 22px
.table-header-button
  border none !important
.el-tabs--border-card
  border none
>>> .el-tabs--border-card>.el-tabs__header
  border none
>>>.el-table-button-text
  color #1890FF
>>>.el-table-button-text.is-disabled
  color #C0C4CC
>>>.table-status
  display flex
  flex-direction row
  align-items center
>>>.el-table-text
  width calc(100% - 112px)
>>>.cell-content-grid
  width 100%
  height 50px
  line-height 50px
  padding-left 12px
  overflow hidden
  display -webkit-box
  display -moz-box
  text-overflow ellipsis
  -webkit-line-clamp 2
  -webkit-box-orient vertical
  white-space normal
.grid-tooltip-icon
  margin 3px 0 0 10px
  color #333
  font-size 16px
>>> .el-loading-spinner
  .icon-empty
    display block
    width 100px
    height 10px
  .el-loading-text
    line-height 16px
    font-size 12px
.table-operate-nav
  display flex
  flex-flow row nowrap
  >.el-button
    margin-left 20px
</style>
